enum GameRowVisualType {
  Standard = "Standard",
  StandardKo = "StandardKo",
}

export default GameRowVisualType;
